/**
 * Runtime check for non-prod hostnames.
 * Used for UI-only behavior (e.g. showing dev indicators).
 * NOTE: This does NOT bypass authentication. All auth flows go through OAuth providers.
 */
export function isLocalModeHostname(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname.toLowerCase();
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.includes('amazonaws.com') ||
    h.includes('elb.') ||
    h.includes('staging') ||
    h.startsWith('k8s-')
  );
}

/**
 * Indicates if the app is running in a development/local environment.
 * NOTE: This does NOT skip authentication. Use for non-auth UI behavior only.
 */
export function isLocalMode(): boolean {
  return (
    import.meta.env.DEV === true ||
    import.meta.env.VITE_LOCAL_MODE === 'true' ||
    isLocalModeHostname()
  );
}
